export function checkDataLayerAvailable() {
  return typeof dataLayer !== 'undefined' && dataLayer !== undefined;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function dataLayerPushEvent(eventName: string, dataObject: any) {
  if (checkDataLayerAvailable()) {
    const pushMessage = Object.assign({ event: eventName }, dataObject);
    dataLayer.push(pushMessage);
  }
}
